import { render } from "./TelegramUserLinkPanel.vue?vue&type=template&id=6ff50122&scoped=true"
import script from "./TelegramUserLinkPanel.vue?vue&type=script&lang=js"
export * from "./TelegramUserLinkPanel.vue?vue&type=script&lang=js"

import "./TelegramUserLinkPanel.vue?vue&type=style&index=0&id=6ff50122&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff50122"]])

export default __exports__